import React from 'react';
import { StaticImageData } from 'next/image';

import { Page } from '../../../payload/payload-types';
import { Media } from '@/app/_components/Media';
import classes from './index.module.scss';

type Props = Extract<Page['layout'][0], { blockType: 'mediaBlock' }> & {
  staticImage?: StaticImageData;
  id?: string;
};

export const MediaBlock: React.FC<Props> = props => {
  const { media, position = 'default', staticImage } = props;

  return (
    <div className={classes.mediaBlock}>
      <Media resource={media} src={staticImage} imageSize='landscape' />
    </div>
  );
};
